import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=7b421022&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClientDashboard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=7b421022&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b421022",
  null
  
)

export default component.exports